// extracted by mini-css-extract-plugin
module.exports = {"blotterLogo":"BlotterLogo_blotterLogo__d_RGW","icon":"BlotterLogo_icon__OY8YM","text":"BlotterLogo_text__rbwdB"};